const meta = {
  optimizations: 'Apply optimizations',
  'prometheus-backend': 'Serve as a Prometheus backend',
  'scrape-prometheus-native-histograms': 'Scrape Prometheus native histograms',
};

export default meta;
